/**
 * Типы словарей
 */

import { ObjectValueType } from "../types/utilityTypes/ObjectValueType";

export const DicTypes = {
  StorageType: "storage_type",
  EntityObjectType: "entity_object_type",
  InvoicePeriod: "invoice_period",
  PeriodAlignment: "period_alignment",
  InvoiceCategory: "invoice_category",
  ReportGroup: "report_group",
  UserType: "user_type",
  BillType: "bill_type",
  NotificationSeverity: "notification_severity",
  UnblockingReason: "unblocking_reason",
  IndAddressType: "ind_address_type",
  PhoneType: "phone_type",
  BillPeriod: "bill_period",
  PaymentGoalType: "payment_goal_type",
  ReportType: "report_type",
  RangeType: "range_type",
  TariffPeriodAlignment: "tariff_period_alignment",
  PolicyType: "policy_type",
  BlockingRequestStatus: "blocking_request_status",
  TaxType: "tax_type",
  ServiceStatus: "service_status",
  PeriodType: "period_type",
  PolicyContext: "policy_context",
  PayUsageStatus: "pay_usage_status",
  RateMode: "rate_mode",
  AdjustmentType: "adjustment_type",
  OfferingStatus: "offering_status",
  AuthLinkType: "auth_link_type",
  OfferingProlongType: "offering_prolong_type",
  ObjectAttrType: "object_attr_type",
  Currency: "currency",
  GlnFilterDirection: "gln_filter_direction",
  TaskStatus: "task_status",
  Product: "product",
  EmailType: "email_type",
  AddressType: "address_type",
  AgrStatus: "agr_status",
  ConditionType: "condition_type",
  LifespanPeriod: "lifespan_period",
  NotificationScope: "notification_scope",
  ExternalReportType: "external_report_type",
  TestType: "test_type",
  PriceUnit: "price_unit",
  PaymentSourceType: "payment_source_type",
  BlockingSourceType: "blocking_source_type",
  ValidationStatus: "validation_status",
  Country: "country",
  ServiceUsageDirection: "service_usage_direction",
  ValueType: "value_type",
  PreprocessorFiltration: "preprocessor_filtration",
  AccType: "acc_type",
  PriceEvent: "price_event",
  PolicyStatus: "policy_status",
  PlLineStatus: "pl_line_status",
  IdDocType: "id_doc_type",
  GroupType: "group_type",
  RuleAccessType: "rule_access_type",
  ServiceUsageDocumentType: "service_usage_document_type",
  PolicyAction: "policy_action",
  ServiceMode: "service_mode",
  CardinalityType: "cardinality_type",
  UserScope: "user_scope",
  TransactionType: "transaction_type",
  PropertyStorageType: "property_storage_type",
  BundleType: "bundle_type",
  PropertyViewMode: "property_view_mode",
  TariffStatus: "tariff_status",
  PaymentType: "payment_type",
  PlBatchStatus: "pl_batch_status",
  TariffModelType: "tariff_model_type",
  PriceType: "price_type",
  Position: "position",
  Region: "region",
  MultiplType: "multipl_type",
  SubsType: "subs_type",
  AuthRole: "auth_role",
  InvoiceStatus: "invoice_status",
  ServiceUsageStatus: "service_usage_status",
  ActionType: "action_type",
  IdentifierType: "identifier_type",
  AuthPermission: "auth_permission",
  ServiceUsageProcessingType: "service_usage_processing_type",
  Units: "units",
  RateType: "rate_type",
  PayStatus: "pay_status",
  ChargeName: "charge_name",
  RuleType: "rule_type",
  GroupDomain: "group_domain",
  RateSourceType: "rate_source_type",
  ProfileType: "profile_type",
  PrepaymentPeriod: "prepayment_period",
  PaymentStatus: "payment_status",
  AccStatus: "acc_status",
  AccessMode: "access_mode",
  BillStatus: "bill_status",
  RequiredType: "required_type",
  BlockingReason: "blocking_reason",
  TariffType: "tariff_type",
  OfferingAccessType: "offering_access_type",
  CurrencyRateType: "currency_rate_type",
  ViewModeMask: "view_mode_mask",
  NotificationDeliveryChannel: "notification_delivery_channel",
  DataType: "data_type",
} as const;

export type DicTypes = ObjectValueType<typeof DicTypes>;
